const C = {
  name: "WhiteBoard",
  dimensions: { width: 41, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_27_2145)">
    <path d="M38.0024 24.9967H3.00244C2.45244 24.9967 2.00244 24.5468 2.00244 23.9969V5.00168H20.0024H37.0024C37.5524 5.00168 38.0024 5.45157 38.0024 6.00143V24.9967ZM38.0024 3.00218H21.0024V1.00268C21.0024 0.452817 20.5524 0.00292969 20.0024 0.00292969C19.4524 0.00292969 19.0024 0.452817 19.0024 1.00268V3.00218H2.00244C0.902441 3.00218 0.00244141 3.90195 0.00244141 5.00168V24.9967C0.00244141 26.0964 0.902441 26.9962 2.00244 26.9962H12.8524L10.0424 38.7632C9.91244 39.3031 10.2424 39.843 10.7824 39.9729C10.8624 39.9929 10.9424 40.0029 11.0124 40.0029C11.4624 40.0029 11.8724 39.693 11.9824 39.2331L14.9124 26.9962H19.0024V38.9932C19.0024 39.543 19.4524 39.9929 20.0024 39.9929C20.5524 39.9929 21.0024 39.543 21.0024 38.9932V26.9962H25.0924L28.0124 39.2231C28.1224 39.683 28.5324 39.9929 28.9824 39.9929C29.0624 39.9929 29.1424 39.9829 29.2124 39.9629C29.7524 39.833 30.0824 39.2931 29.9524 38.7532L27.1524 26.9962H38.0024C39.1024 26.9962 40.0024 26.0964 40.0024 24.9967V5.00168C40.0024 3.90195 39.1024 3.00218 38.0024 3.00218Z" />
    <path d="M30.5024 22.9977H35.0024C35.5524 22.9977 36.0024 22.5477 36.0024 21.9977C36.0024 21.4477 35.5524 20.9977 35.0024 20.9977H30.5024C29.9524 20.9977 29.5024 21.4477 29.5024 21.9977C29.5024 22.5477 29.9524 22.9977 30.5024 22.9977Z" />
    </g>
    <defs>
    <clipPath id="clip0_27_2145">
    <rect width="40" height="40" fill="currentColor" transform="translate(0.00244141 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  C as WhiteBoard
};
